import store from '@/store'
import { DoctorUtil } from '@/utils/Doctor'

import { BasketHelper } from '@/helpers/Basket'

import { productAVMtypes } from '@/modules/MedicalOfficeWidget/config/constances'

export const DoctorHelper = {
  ...DoctorUtil,

  getDoctorName(doctor) {
    if (!doctor) {
      return undefined
    }

    const transformedDoctor = BasketHelper.transferProductDoctor(doctor)
    return `${transformedDoctor.name}, ${transformedDoctor.town}`
  },

  getDoctorFromPerson(personId) {
    const person = store.getters['basket/getPerson'](personId)

    return DoctorUtil.getMedicalProduct(person).doctor
  },

  appliesToProduct(productId, doctor) {
    const searchKey = productAVMtypes[productId]
    return !!doctor.medicalOfficeNets.find(n => n.avmDefinition === searchKey)
  },
}
